module.exports = __webpack_public_path__ + "media/src/img/payment/mbank_tenge_som_qr_modal-44dcf9c2d66a5b880858f0a37f2dd186.jpg";